import { Injectable } from '@angular/core';
/**
 * @hidden
 */
var ToolNavigationService = /** @class */ (function () {
    function ToolNavigationService() {
    }
    ToolNavigationService.prototype.register = function (rendererService, location) {
        if (location === 'toolbar') {
            this.toolbarRenderer = rendererService;
        }
        else {
            this.overflowRenderer = rendererService;
        }
    };
    ToolNavigationService.prototype.canFocus = function () {
        return false;
    };
    ToolNavigationService.prototype.focus = function () { };
    ToolNavigationService.prototype.defocus = function () { };
    ToolNavigationService.prototype.hasFocus = function () {
        return false;
    };
    ToolNavigationService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ToolNavigationService.ctorParameters = function () { return []; };
    return ToolNavigationService;
}());
export { ToolNavigationService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-toolbar/dist/es/navigation/tool-navigation.service.js
// module id = ../../../../@progress/kendo-angular-toolbar/dist/es/navigation/tool-navigation.service.js
// module chunks = vendor